var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.componentData && _vm.componentData.acf_fc_layout)?_c(_vm.componentData.acf_fc_layout,_vm._b({tag:"component"},'component',_vm.componentData,false)):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }